import { Injectable } from '@angular/core';
import { BaseProductCardViewModel } from '../base-product-card/base-product-card-view-model';

@Injectable()
export class HalfImageCardViewModel extends BaseProductCardViewModel {}
